import HideMenuPage from "./HideMenuPage";

export {HideMenuPage}
export default HideMenuPage
